import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

export default class Sliders {

  review() {
    new Swiper(".review-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      pagination: {
        el: ".review-slider-pagination",
        clickable: true,
      },
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 5000,
  		},
    });
  }

  result() {
    new Swiper(".result-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      //spaceBetween: 30,
      autoplay: {
  			delay: 5000,
  		},
      pagination: {
        el: ".result-slider-pagination",
        clickable: true,
       // dynamicBullets: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }

  yt() {
    new Swiper(".yt-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".yt-slider-pagination",
        clickable: true,
      },
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 5000,
  		},
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      }
    });
  }


  info() {
    new Swiper(".info-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
  			delay: 5000,
  		},
      pagination: {
        el: ".info-slider-pagination",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 60,
        }
      },
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 5000,
  		},
    });
  }


  team() {
    new Swiper(".team-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
  			delay: 5000,
  		},
      pagination: {
        el: ".team-slider-pagination",
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 80,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }


  video() {
    new Swiper(".video-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
  			delay: 5000,
  		},
      pagination: {
        el: ".video-slider-pagination",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 0,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }

  futureCource() {
    new Swiper(".future-course-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
      pagination: {
        el: ".future-course-slider-pagination",
        clickable: true,
      },
      autoplay: {
  			delay: 5000,
  		},
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: true,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }

  cource() {
    new Swiper(".course-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
      pagination: {
        el: ".course-slider-pagination",
        clickable: true,
      },
      autoplay: {
  			delay: 5000,
  		},
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: true,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }


  steps() {
    new Swiper(".steps-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
  			delay: 5000,
  		},
      pagination: {
        el: ".steps-slider-pagination",
        clickable: true,
       // dynamicBullets: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      }
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      // autoplay: {
  		// 	delay: 5000,
  		// },
    });
  }


  cg() {
    new Swiper(".cg-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      centeredSlides: true,
      effect: "fade",
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 3000,
  		},
    });
  }

  
    init() {
      document.querySelector('.review-slider') ? this.review() : null;
      document.querySelector('.result-slider') ? this.result() : null;
      document.querySelector('.yt-slider') ? this.yt() : null;
      document.querySelector('.info-slider') ? this.info() : null;
      document.querySelector('.team-slider') ? this.team() : null;
      document.querySelector('.video-slider') ? this.video() : null;
      document.querySelector('.future-course-slider') ? this.futureCource() : null;
      document.querySelector('.course-slider') ? this.cource() : null;
      document.querySelector('.steps-slider') ? this.steps() : null;
      document.querySelector('.cg-slider') ? this.cg() : null;
    }
}